import { get } from "lodash-es";
export function getIsEditorMode() {
  try {
    const isEditorMode = get(window, 'w.mode') === 'editor';
    return isEditorMode;
  } catch (error) {
    return false;
  }
}
//# sourceMappingURL=getIsEditorMode.js.map
